import store from '../redux/store';
import { ModalDataType, OrdersModalType, ShowActiveRentalItem } from '../types/order';

export const prePopulateModalData = (
  modalType: OrdersModalType,
  rental?: ShowActiveRentalItem,
): ModalDataType => {
  let rentalModalData: ModalDataType;
  const authContext = store.getState().auth.authContext;
  const personalDetailsState = store.getState().profile.personalDetails.data;

  switch (modalType) {
    case OrdersModalType.PURCHASE_ORDER_MODAL:
      rentalModalData = {
        rentalId: String(rental?.rentalId ?? ''),
        purchaseOrderName: String(rental?.purchase_order.name ?? ''),
        startDate: rental?.purchase_order.purchase_order_start_date ?? '',
        endDate: rental?.purchase_order.purchase_order_end_date ?? '',
        amount: Number(rental?.purchase_order.budget_amount) ?? '',
        purchaseOrderId: Number(rental?.purchase_order.purchase_order_id) ?? '',
      };
      break;

    case OrdersModalType.SERVICE_ORDER_MODAL:
      rentalModalData = {
        assetId: String(rental?.assetId ?? ''),
        assetType: rental?.equipment.categoryName ?? '',
        assetAddress: rental?.jobsiteAddress ?? '',
        serviceLocation: rental?.service_location_city ?? '',
        locationId: String(rental?.market_id ?? ''),
        serviceDescription: rental?.equipment.description ?? '',
        fullName: [personalDetailsState?.firstName, personalDetailsState?.lastName].join(' '),
        companyName: authContext.companyName ?? '',
        phone: personalDetailsState?.phone ?? '',
        email: personalDetailsState?.email ?? '',
      };
      break;

    case OrdersModalType.SCHEDULE_OFFRENT_ORDER_MODAL:
      rentalModalData = {
        equipmentName: rental?.equipment.className ?? '',
        equipmentId: [rental?.equipment.makeName, rental?.model].join(' '),
        pickupDate: rental?.off_rent_date_requested,
        notes: '',
        rentalId: String(rental?.rentalId ?? ''),
      };
      break;

    case OrdersModalType.CANCEL_OFFRENT_ORDER_MODAL:
      rentalModalData = {
        rentalId: String(rental?.rentalId ?? ''),
      }
      break;

    default:
      throw new Error('Unknown modal type');
  }
  return rentalModalData;
};
